import { emptyMultiLocaleString } from '@/domain'
import { breakpoints } from '@/materials'
import styled from '@emotion/styled'
import * as React from 'react'
import { defineMessages, FormattedMessage } from 'react-intl'
import { ArticleTeasers } from '../../components/Articles'
import { ElectionPageIntertitle } from '../../components/election-page-intertitle'
import { LabeledDivider } from '../../elements/index'
import { useEnv } from '../../lib/env'

export interface NewsSectionProps {
  articleIds: string[]
}

const messageDescriptors = defineMessages({
  heading: {
    id: '6QwzNwY',
    defaultMessage: 'News und Analysen',
  },
})

export const NewsSection = ({ articleIds }: NewsSectionProps) => {
  const { intl } = useEnv()

  return (
    <Root>
      <Heading>
        <LabeledDivider label={intl.formatMessage(messageDescriptors.heading)} />
      </Heading>
      <ArticleTeasers articleIds={articleIds} numberOfCards={'three'} />
    </Root>
  )
}

const Root = styled('div')`
  display: grid;
  column-gap: 28px;
  grid-template-columns: repeat(8, 1fr);
  ${breakpoints.large`
    grid-template-columns: repeat(12, 1fr);
    column-gap: 24px;
  `};
`

const Heading = styled('div')`
  grid-column: 1 / -1;
  ${breakpoints.large`
    grid-column: 1 / span 3;
  `}
`

export function ElectionNewsSection({ articleIds }: NewsSectionProps) {
  return (
    <>
      <ElectionPageIntertitle
        heading={{
          def: <FormattedMessage {...messageDescriptors.heading} />,
          mls: emptyMultiLocaleString,
        }}
      />
      <ArticleTeasers articleIds={articleIds} numberOfCards={'three'} />
    </>
  )
}
